import SilubiLogo from "../../Assets/images/logos/silubi-logo-grey.svg";

export default function AppHeader() {
    return (
        <div className="App-header">
            <img src={SilubiLogo} alt="Silubi&trade;" className="silubi-logo" />
        </div>
    );
}